import { openURL, Platform, Dialog } from 'quasar';
import { Browser } from 'app/src-capacitor/node_modules/@capacitor/browser';
import WarningDialog from 'src/components/dialogs/Warning.vue';
import { routerInstance } from './router';

export const openURLBrowser = async (url: string, inViewer?: boolean) => {
  if (Platform.is.capacitor && url.split('://')[0] !== 'maps') {
    await Browser.open({ url });
  } else {
    if (inViewer) {
      routerInstance
        .push({ name: 'ServicesViewer', params: { url: url } })
        .catch(console.log);
    } else {
      openURL(url);
    }
  }
};

export const safeOpenURLBrowser = (url: string, inViewer?: boolean) => {
  if (!inViewer) {
    Dialog.create({
      component: WarningDialog,
      componentProps: {
        title: 'Te estamos llevando con nuestro partner',
        subtitle: `Estás siendo saliendo de Snabb al sitio <br /><b>${url}</b>`,
        text: 'Verifica tu configuración de ventanas emergentes'
      }
    }).onOk(() => {
      openURLBrowser(url, inViewer).catch(console.error);
    });
  } else {
    openURLBrowser(url, inViewer).catch(console.error);
  }
};
